/* « Tout le catalogue » rangé en rayons — barre des gammes.

   Sans ce script la page marche déjà : les liens #designed, #luxe… sautent
   à leur section. Il n'ajoute que trois choses : le soulignement de la gamme
   en cours, le défilement doux, et la gamme active gardée visible dans la
   barre sur téléphone.

   Le thème ne fait pas défiler la fenêtre sur ordinateur (.page-wrapper
   défile) mais la fenêtre sous 768 px : tout se mesure en
   getBoundingClientRect, et le défilement s'écoute en capture, qui attrape
   les deux. */
(() => {
  'use strict';
  const root = document.querySelector('.qc-root');
  const bar = root && root.querySelector('.qc-jump');
  if (!bar || root.dataset.bound) return;
  root.dataset.bound = '1';

  const list = bar.querySelector('ul');
  const links = [...bar.querySelectorAll('a[data-k]')];
  const sections = links.map(a => document.getElementById(a.dataset.k)).filter(Boolean);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  // hauteur de ce qui reste collé en haut (header), pour poser la barre dessous
  function measureTop() {
    let top = 0;
    for (const el of document.querySelectorAll('.mm-header, .mm-promo, .qt-home.mm')) {
      const cs = getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        top = Math.max(top, el.getBoundingClientRect().height + (parseFloat(cs.top) || 0));
      }
    }
    root.style.setProperty('--qc-top', `${Math.round(top)}px`);
  }

  // garde la gamme active visible dans la barre, sans faire bouger la page
  function keepVisible(li) {
    if (!li || list.scrollWidth <= list.clientWidth) return;
    const l = li.offsetLeft - 16;
    const r = li.offsetLeft + li.offsetWidth + 16 - list.clientWidth;
    const behavior = reduced.matches ? 'auto' : 'smooth';
    if (list.scrollLeft > l) list.scrollTo({ left: l, behavior });
    else if (list.scrollLeft < r) list.scrollTo({ left: r, behavior });
  }

  let current = null;
  function spy() {
    const line = bar.getBoundingClientRect().bottom + 24;
    let hit = sections[0];
    for (const s of sections) if (s.getBoundingClientRect().top - line <= 1) hit = s;
    if (!hit || hit.id === current) return;
    current = hit.id;
    for (const a of links) {
      const on = a.dataset.k === current;
      a.classList.toggle('is-on', on);
      if (on) { a.setAttribute('aria-current', 'true'); keepVisible(a.parentElement); }
      else a.removeAttribute('aria-current');
    }
  }

  let queued = false;
  document.addEventListener('scroll', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; spy(); });
  }, { capture: true, passive: true });
  addEventListener('resize', () => { measureTop(); spy(); });

  // clic sur une gamme : défilement doux, adresse #gamme, focus sur le titre
  bar.addEventListener('click', e => {
    const a = e.target.closest('a[data-k]');
    const sec = a && document.getElementById(a.dataset.k);
    if (!sec) return;
    e.preventDefault();
    sec.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(null, '', `#${sec.id}`);
    const h = sec.querySelector('[tabindex="-1"]');
    if (h) h.focus({ preventScroll: true });
  });

  measureTop();
  spy();
})();
